import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskOverviewRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-overview',
	// /settings/overview
	path: '/jira/servicedesk/projects/:projectKey/settings/overview',
	exact: true,
};
